import { render, staticRenderFns } from "./CargaDialog.vue?vue&type=template&id=57b9f2f6&scoped=true&"
import script from "./CargaDialog.vue?vue&type=script&lang=ts&"
export * from "./CargaDialog.vue?vue&type=script&lang=ts&"
import style0 from "./CargaDialog.vue?vue&type=style&index=0&id=57b9f2f6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57b9f2f6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VCard,VDialog,VProgressCircular})
